export default {
  title: 'Gallery',
  noImages: 'No images have been posted yet.',
  loadImageFailedErrorMessage: 'An error occurred and the image could not be loaded. Please try again.'
}
